var map = {
	"./brand.de-CH.json": 1575,
	"./brand.de-DE.json": 1576,
	"./brand.en-CA.json": 1577,
	"./brand.en-GB.json": 1578,
	"./brand.en-IN.json": 1579,
	"./brand.en-ME.json": 1580,
	"./brand.en-US.json": 1581,
	"./brand.es-EM.json": 1582,
	"./brand.es-ES.json": 1583,
	"./brand.fr-BE.json": 1584,
	"./brand.fr-CA.json": 1585,
	"./brand.fr-CH.json": 1586,
	"./brand.nl-BE.json": 1587,
	"./brand.nl-NL.json": 1588,
	"./brand.pl-PL.json": 1589,
	"./brand.pt-BR.json": 1590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1574;